module.exports = __webpack_public_path__ + "img/shop.db9db8c4.png";